import(/* webpackMode: "eager" */ "/app/apps/armstrong/src/app/error.tsx");
